import { render, staticRenderFns } from "./QuickMessage.vue?vue&type=template&id=64bda960&scoped=true&"
import script from "./QuickMessage.vue?vue&type=script&lang=js&"
export * from "./QuickMessage.vue?vue&type=script&lang=js&"
import style0 from "./QuickMessage.vue?vue&type=style&index=0&id=64bda960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bda960",
  null
  
)

export default component.exports